import { render, staticRenderFns } from "./LegalUpdateNotice.vue?vue&type=template&id=512829c7&scoped=true"
import script from "./LegalUpdateNotice.vue?vue&type=script&lang=js"
export * from "./LegalUpdateNotice.vue?vue&type=script&lang=js"
import style0 from "./LegalUpdateNotice.vue?vue&type=style&index=0&id=512829c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512829c7",
  null
  
)

export default component.exports